import React from 'react'

function TextPropertyValue({ property, value, accessor }) {

  const mapToAccessor = (data) => {
    if (!data) {
      return 'Sem dados';
    }
    return data.map(x => <li key={x.id || Math.random()}>{x[accessor] || 'Sem dados'}</li>);
  }

  const PropertyText = () => <span className="h4" style={{ fontWeight: 'bold' }}>{property}: &nbsp;</span>
  
  const ValueText = () => Array.isArray(value) ? <ul>{mapToAccessor(value)}</ul> : <span>{value || 'Sem dados'}</span>
  
  return (
    <div>
      <PropertyText />
      <ValueText />
    </div>
  )
}

export default TextPropertyValue



// WEBPACK FOOTER //
// ./src/component/Information/TextPropertyValue.js